import { TOGGLE_SEGMENT_SETTINGS } from "../types";

export const toggleSegmentSettings = (isEnabled) => {
  return {
    type: TOGGLE_SEGMENT_SETTINGS,
    payload: isEnabled,
  };
};
